import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
  public showSettings: boolean = true;
  public showAboutus: boolean = false;
  constructor() { }

  ngOnInit() {
  }

  ShowAboutus(){
    this.showAboutus = true;
    this.showSettings = false;
 }

}
